import React from 'react'
import { Button } from '@/components/ui/button'
import Datetime from '../../../../datetime'
import store from '../../../../../state/store'

class CustomerPreferences extends React.Component {

  onDiscard = () => {
    store.emit('lesson_plan:lesson_order:customer_preferences:discard', this.props.lesson_plan.id, this.props.lesson_order.id)
  }

  renderPaymentTerm() {
    const payment_term = this.props.lesson_order.customer_preferences.payment_term

    if (payment_term === 'monthly_credit_card') {
      return <span>Monthly Subscription (Automatic card payments)</span>
    }
    else if (payment_term === 'monthly_subscription_manual') {
      return <span>Monthly Subscription (Manual Payments)</span>
    }
    else if (payment_term === 'monthly_debit_order') {
      return <span>Monthly Debit Order</span>
    }
    else if (payment_term === 'full_payment_upfront') {
      return <span>Full Payment Upfront</span>
    }
    else if (payment_term === 'eft_instalments') {
      return <span>EFT Instalments</span>
    }

    return null
  }

  renderLessonDuration() {
    const lesson_duration = parseInt(this.props.lesson_order.customer_preferences.lesson_duration)

    if (lesson_duration === 45) {
      return <span>45 Minute Lessons</span>
    }
    else if (lesson_duration === 60) {
      return <span>1 Hour Lessons</span>
    }
    else if (lesson_duration === 90) {
      return <span>1.5 Hour Lessons</span>
    }
    else if (lesson_duration === 120) {
      return <span>2 Hour Lessons</span>
    }

    return null
  }

  render() {
    const lesson_order = this.props.lesson_order
    const customer_preferences = lesson_order.customer_preferences
    const customer_placed_at = this.props.lesson_order.customer_placed_at

    return (
      <div className="rounded-[10px] border border-info/40 bg-info/10 p-4 text-foreground">
        <div className="text-sm font-semibold">
          Customer selected the following options at <Datetime date={customer_placed_at}/>:
        </div>
        <ul className="mt-3 list-disc pl-5 text-sm font-semibold">
          <li>{this.renderPaymentTerm()}</li>
          <li>{customer_preferences.number_of_instalments} Instalments</li>
          <li>{customer_preferences.lessons_per_week} Lessons Per Week</li>
          <li>{customer_preferences.commitment_in_months} Months Commitment</li>
          <li>{this.renderLessonDuration()}</li>
        </ul>
        <div className="mt-3 flex justify-end">
          <Button variant="warning" size="sm" onClick={this.onDiscard}>Discard</Button>
        </div>
      </div>
    )
  }
}

export default CustomerPreferences